var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMineralOil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_5342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 0H0V86H86V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4002 52C56.6002 43.3 49.2002 51.6 45.8002 55.5C42.5002 59.6 38.2002 65.2 36.0002 70.5C43.1002 71.3 49.0002 69.4 52.8002 65.1C57.0002 60.3 61.3002 48.2 66.7002 39.5C62.2002 39.2 57.3002 40 52.8002 41.5L51.7002 39.9C50.2002 37.1 48.4002 34.6 46.4002 32C43.4002 28 40.4002 23.8 38.9002 18.8C38.2002 14.3 35.6002 14.2 34.7002 18.8C33.2002 23.8 30.1002 28 27.2002 32C23.1002 37.6 19.1002 42.9 19.3002 50.2C19.4002 55.2 21.2002 59.1 23.8002 61.9C26.8002 65.1 31.1002 66.9 35.4002 67.2C38.0002 61.8 43.0002 56.1 47.4002 52ZM48.5002 43.2C39.0002 47.6 31.8002 55.1 33.2002 62.4C30.9002 61.8 28.7002 60.6 27.1002 58.9C25.1002 56.8 23.8002 53.9 23.8002 50.1C23.7002 44.3 27.2002 39.6 30.8002 34.6C32.9002 31.7 35.2002 28.7 36.9002 25.3C38.6002 28.7 40.8002 31.7 43.0002 34.6C44.8002 37.1 46.6002 39.5 47.9002 41.9L48.5002 43.2Z",
    fill: "#81061A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_5342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMineralOil);
export default __webpack_public_path__ + "static/media/mineralOil.d46ba3491a6188903d8ed2e7d8c038e3.svg";
export { ForwardRef as ReactComponent };